module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addService($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Service")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Services\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.services), function(service) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(service.title))]), _vm._v(" "), _c('td', [_vm._v("€ " + _vm._s(_vm.numeral(service.price).format('0,0.00')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.description))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('strong', [_vm._v(_vm._s(service.letter))])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editService(service)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Service")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editService(service)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Service")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteService(service)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete Service")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete service "), (_vm.serviceForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.serviceForDelete.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteService(_vm.serviceForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "serviceModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.service._id) ? _c('span', [_vm._v("Edit Service")]) : _c('span', [_vm._v("Add Service")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.title),
      expression: "service.title"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.service.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "twelve wide field"
  }, [_c('label', [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "ui right icon input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.price),
      expression: "service.price"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": (_vm.service.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.price = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "euro icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "four wide field"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "ui right icon input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.priceType),
      expression: "service.priceType"
    }],
    staticClass: "ui selection",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.service.priceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed"
    }
  }, [_vm._v("Fixed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "perPerson"
    }
  }, [_vm._v("Per Person")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.description),
      expression: "service.description"
    }],
    staticClass: "ui input",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.service.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Letter in admin booking panel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.letter),
      expression: "service.letter"
    }],
    staticClass: "ui input",
    attrs: {
      "maxlength": "1"
    },
    domProps: {
      "value": (_vm.service.letter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.letter = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveService
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save Service\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Title\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Price\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Description\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Letter\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c981794"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Services.vue
// module id = 749
// module chunks = 1